module.exports = __webpack_public_path__ + "img/medalhaOn.a72dcb16.png";